export const STATUS = 'status';
export const MESSAGE_DELETED_STATUS = 'messageDeletedStatus';